import { on } from "@ngrx/store";
import { DeveloperState } from "../developer.state";
import { SendReminderActions } from "./send-reminder.actions";
import { PagesStore } from "../../../pages.state";

// **************************************************************************
// HELPER: Update developer state within PagesStore
// **************************************************************************

function withDeveloper(state: PagesStore, updater: (developer: DeveloperState) => DeveloperState): PagesStore {
    return { ...state, developer: updater(state.developer) };
}

// **************************************************************************
// SEND REMINDER REDUCER (array format for PagesStore)
// **************************************************************************

const send = on(SendReminderActions.send, (state: PagesStore, { customerSystemId }) => withDeveloper(state, developerState => ({
    ...developerState,
    sendReminder: {
        ...developerState.sendReminder,
        sendingCustomerSystemIds: [...developerState.sendReminder.sendingCustomerSystemIds, customerSystemId],
        lastResult: undefined,
    },
    error: null,
})));

const sendSuccess = on(SendReminderActions.sendSuccess, (state: PagesStore, { customerSystemId, result }) => withDeveloper(state, developerState => ({
    ...developerState,
    sendReminder: {
        ...developerState.sendReminder,
        sendingCustomerSystemIds: developerState.sendReminder.sendingCustomerSystemIds.filter(id => id !== customerSystemId),
        lastResult: result,
    },
    error: null,
})));

const sendFailure = on(SendReminderActions.sendFailure, (state: PagesStore, { customerSystemId, error }) => withDeveloper(state, developerState => ({
    ...developerState,
    sendReminder: {
        ...developerState.sendReminder,
        sendingCustomerSystemIds: developerState.sendReminder.sendingCustomerSystemIds.filter(id => id !== customerSystemId),
    },
    error,
})));

const clearLastResult = on(SendReminderActions.clearLastResult, (state: PagesStore) => withDeveloper(state, developerState => ({
    ...developerState,
    sendReminder: {
        ...developerState.sendReminder,
        lastResult: undefined,
    },
})));

export const sendReminderReducer = [
    send,
    sendSuccess,
    sendFailure,
    clearLastResult,
];
